module.exports = __webpack_public_path__ + "static/media/styledDatepicker-Chevrom-Left.116700ec.svg";